var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('TableFilter',{attrs:{"filters":[
    {
      type: 'NumberRangeFilter', queryKey: 'salary', key: 'salary',
      label: 'Payment(€)', props: {}
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'employment_type', key: 'employment_type',
      label: 'Position', props: {options: _vm.employment_positions}
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'type', key: 'type',
      label: 'Job type', props: {options: ['delivery', 'charter', 'permanent', 'temporary']}
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'employer__type', key: 'employer__type',
      customMapper: function (values, key) {
        var valuesByKey = {
          'owner': 'employer__type',
          'charterer': 'employer__type',
          'broker': 'employer__profile__company_type',
          'company': 'employer__profile__company_type'
        }
        return {key: key, value: values.map(function (v) { return (Object.assign({}, v, {queryKey: valuesByKey[v.value]})); })}
      },
      label: 'Created by',
      props: {options: ['owner', 'charterer', 'broker', 'company']}
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'vessel_type', key: 'vessel_type',
      label: 'Vessel type', props: {options: ['Sailing boat', 'Speed boat']}
    },
    {
      type: 'NumberRangeFilter', queryKeykey: 'vessel_size_ft', key: 'vessel_size_ft',
      label: 'Vessel size(ft)', props: {}
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'country_from', key: 'country_from',
      label: 'Country from', props: {options: _vm.countries}
    },
    {
      type: 'TextFilter', queryKey: 'harbor_from__icontains', key: 'harbor_from__icontains',
      label: 'Harbour from'
    },
    {
      type: 'MultipleAutoCompleteFilter', queryKey: 'skills', key: 'languages',
      label: 'Languages', props: {options: _vm.languages}
    },
    {
      type: 'DateRangeFilter', queryKey: 'from_date', key: 'from_date',
      label: 'Starts', props: {}
    },
    {
      type: 'DateRangeFilter', queryKey: 'to_date', key: 'to_date',
      label: 'Ends', props: {}
    }
  ]},on:{"input":function (query) { return _vm.$router.push({ query: query, offset: 0, limit: 10 }); }}}),_c('JobsTable',{attrs:{"query":_vm.query},on:{"pageChange":function (p) { return _vm.$router.push({ query: Object.assign({}, _vm.$route.query, {offset: 10 * (p - 1)}) }); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }